import { Button, Flex, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotAuthorized() {
	const navigate = useNavigate();
	return (
		<Flex
			flex={1}
			align="center"
			justify="center"
			style={{ minHeight: '100vh', }}
		>
			<Result
				status="403"
				title="403"
				subTitle="Ops! Você não tem as permissões necessárias para acessar esse dashboard"
				extra={
					<Button onClick={() => navigate('/')} type="primary">
                        Voltar para o início
					</Button>
				}
			/>
		</Flex>
	);
}
